
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.308 11.923l-1.345-.794a6.34 6.34 0 000-2.264l1.345-.794a.394.394 0 00.174-.452 8.076 8.076 0 00-1.728-3.051.374.374 0 00-.467-.074l-1.346.793a5.933 5.933 0 00-1.92-1.132V2.57a.385.385 0 00-.298-.377 7.781 7.781 0 00-3.45 0 .385.385 0 00-.297.377v1.587a6.12 6.12 0 00-1.92 1.132l-1.343-.793a.37.37 0 00-.467.074 8.027 8.027 0 00-1.728 3.052.39.39 0 00.173.451l1.346.794a6.343 6.343 0 000 2.264l-1.346.794a.393.393 0 00-.173.451 8.075 8.075 0 001.728 3.052c.12.132.315.165.467.074l1.346-.793c.565.496 1.216.88 1.92 1.132v1.587c0 .18.124.339.298.377a7.782 7.782 0 003.45 0 .385.385 0 00.296-.377v-1.587a6.121 6.121 0 001.921-1.132l1.346.793a.37.37 0 00.467-.074 8.026 8.026 0 001.728-3.052.402.402 0 00-.177-.454zm-7.31.654c-1.393 0-2.527-1.158-2.527-2.58 0-1.423 1.134-2.58 2.527-2.58 1.393 0 2.528 1.157 2.528 2.58 0 1.422-1.135 2.58-2.528 2.58z","fill":"#191F2D"}})])
          )
        }
      }
    